// extracted by mini-css-extract-plugin
export default {"pagination-container":"Pagination_pagination-container__cZqXF","active":"Pagination_active__gNTfE"};